export const focusHandler = (setFocus: any) => setFocus(true);

export const blurHandler = (evt: any, field: any, setFocus: any) => {
  field.onBlur(evt);
  setFocus(false);
};

export const pasteHandler = (evt: any, name: string, isNumeric?: boolean) => {
  if (name === "confirmPassword") evt.preventDefault();

  if (isNumeric) {
    const pasteData = evt.clipboardData.getData("text");
    if (/[^0-9]/.test(pasteData)) {
      evt.preventDefault();
    }
  }
};
